import { createAsyncThunk } from '@reduxjs/toolkit';

import { sendMessage } from '../../../../../shared/chromeApi';
import { GlobalState } from '../../../../types.global';
import { incrementShells } from '../../../user/slice';
import { getRandomInt, withHttp, checkIsUrl, getTerm } from '../utils';
import { trackSubmit } from './analytics';

import {
  // SearchTag, 
  Suggestion
} from '../types';
import {
  selectHighlighted,
  // selectRendered,
  selectEngine,
  checkPreselectMatch,
} from '../selectors';
import {
  // createFormatAdMarketplaceLongtail,
  createOrganicUrl,
} from '../selectors/suggestions/utils';
import {
  // requestLiteralcoSuggestions,
  // requestAdSuggestions,
  // requestOrganicSuggestions,
  // removeHistorySuggestion,
  // requestAdmarketplaceLongTailSuggestions,
  // findTakeMerchants,
  requestZeropark,
  findZeroParkMerchants,
  findCustomMerchants,
  findAffinityMerchants,
  findAdMarketplaceMerchants,
  findOrganicResults
} from './api';
import { ENGINES } from '../../utils';
import { ChangeEvent, Thunk } from '../../../../types.global';
import { SubmitEvent } from '../../types';
import { selectFeatureFlags } from '../../../../store/selectors';
import {
  selectSuggestions,
  selectChoosenSearchTag,
  selectDisplayedSearchTags,
} from '../selectors';
// import { selectIsUserRegular } from '../../../../store/selectors';
// import {
//   createFormatAdMarketplace,
//   createFormatOrganic,
// } from '../selectors/suggestions/utils';

import * as actions from '../actions';
import { fetchedSuggestions } from '../actions';
import { selectActiveHintId } from '../selectors/hints';
import { fetchInstantResults } from './instantAnswers';
import { getDaysOfUsage } from '../../../story/slice/utils';
// import { fetchThinksuggest } from './thinksuggest';

export const setIsAutofocus =
  (payload: boolean): Thunk =>
    async (dispatch) => {
      dispatch(actions.setIsAutofocus(payload));
    };

let timeout = null;

export const fetchSuggestions =
  ({ term, inputType }: { term: string; inputType: string }): Thunk =>
    async (dispatch, getState) => {
      clearTimeout(timeout);
      timeout = setTimeout(async () => {
        const state = getState();

        // const engine = selectEngine(state);
        // const isRegular = selectIsUserRegular(state);
        const {
          // AD_AUTOSUGGESTION,
          SEARCH_BOX_INSTANT_ANSWERS,
          THINKSUGGEST_ADS,
          // ADMARKETPLACE_FEED,
        } = selectFeatureFlags(state);
        const choosenSearchTag = selectChoosenSearchTag(state);

        // const isAds = !!(() => {
        //   if (choosenSearchTag) return false;
        //   // if (engine === 'google' || choosenSearchTag) return false;
        //   return isRegular ? AD_AUTOSUGGESTION || THINKSUGGEST_ADS : null;
        // })();

        if (!term) return null;

        const searchTerm = choosenSearchTag
          ? `${choosenSearchTag.s} ${term}`
          : term;

        const list = await (() => {
          // const isAdMarketplaceAds = isAds && !THINKSUGGEST_ADS;

          // console.log(ADMARKETPLACE_FEED);

          // if (
          //   isAdMarketplaceAds &&
          //   ADMARKETPLACE_FEED &&
          //   searchTerm.length >= Number(ADMARKETPLACE_FEED)
          // ) {
          //   return Promise.all([
          //     requestAdmarketplaceLongTailSuggestions(term),
          //     requestOrganicSuggestions(searchTerm, engine, choosenSearchTag),
          //   ]).then(createFormatAdMarketplaceLongtail(searchTerm, engine));
          // }

          return Promise.all([
            // findCustomMerchants(searchTerm),
            // findZeroParkMerchants(searchTerm),
            // findAffinityMerchants(searchTerm),
            findAdMarketplaceMerchants(searchTerm),
            findOrganicResults(searchTerm)
            // ]).then(([custom, zp, affinity, organic]) => {
          ]).then(([adMarketplace, organic]) => {

            // const suggestions = createFormatAdMarketplace(
            //   searchTerm,
            //   engine
            // )(data);

            if (getDaysOfUsage(state.user.installationDate) < 3 && !state.user.utmCampaign) {
              return [...organic];
            }

            // const filtered = [...zp, ...affinity].filter(providersSugg =>
            //   !custom.some(customSugg => customSugg.term.toLowerCase() === providersSugg.term.toLowerCase())
            // );

            // return [...custom, ...filtered, ...organic];
            return [...adMarketplace, ...organic];
          });
          // : requestOrganicSuggestions(
          //     searchTerm,
          //     engine,
          //     choosenSearchTag
          //   ).then(async (result): Promise<Suggestion[]> => {
          //     if (isAds && THINKSUGGEST_ADS) {
          //       try {
          //         const simpleList = result.map((el) => el.term || el);
          //         const thinksuggestList = await fetchThinksuggest(
          //           searchTerm,
          //           engine,
          //           simpleList
          //         );

          //         console.log('thinksuggestList', thinksuggestList);

          //         if (thinksuggestList?.length) {
          //           return thinksuggestList;
          //         }
          //       } catch (err) {
          //         console.error('fetchSuggestions:thinksuggest', err);
          //       }
          //     }

          //     return createFormatOrganic(searchTerm, engine)(result);
          //   });
        })();

        dispatch(
          fetchedSuggestions({
            term: searchTerm,
            inputType,
            list,
          })
        );

        list.forEach(item => {
          if (item.type === 'ad') {
            if (item.impressionUrl) {
              const img = new Image();
              img.src = item.impressionUrl;
            }
          }
        });

        const newState = getState();
        const renderedList = selectSuggestions(newState);
        const highlighted = selectHighlighted(newState);

        if (!highlighted && renderedList.length) {
          const [first] = renderedList;
          if (
            (['ad', 'url', 'website'].includes(first.type) ||
              // This is the case for thinksuggest
              (['organic'].includes(first.type) && first.provider)) &&
            inputType !== 'deleteContentBackward' &&
            checkPreselectMatch(first, term)
          ) {
            dispatch(
              actions.suggestionNavigate({
                id: first.id,
                inputType: 'preselected',
              })
            );
          }
        } else if (
          highlighted &&
          newState.search.highlighted.inputType === 'preselected' &&
          renderedList.indexOf(highlighted) !== 0
        ) {
          dispatch(actions.suggestionNavigate({ id: null, inputType: null }));
        }

        const termForInstant = (() => {
          const organic = renderedList.find(({ type }) =>
            ['organic', 'searchTag', 'historyOrganic'].includes(type)
          );
          return organic?.term || term;
        })();

        if (
          SEARCH_BOX_INSTANT_ANSWERS &&
          !THINKSUGGEST_ADS &&
          inputType !== 'preselected' &&
          termForInstant &&
          termForInstant !==
          newState.search.instantResults.data?.queryContext.originalQuery
        ) {
          dispatch(fetchInstantResults(termForInstant));
        }
      }, 200);
    };

export const fetchEntities = createAsyncThunk(
  'searchForm/fetchEntities',
  async () => {
    const [{ default: searchTags }, zp] = await Promise.all([
      import('../data/searchTags.json'),
      requestZeropark(),
    ]);

    return { searchTags, zp };
  }
);

export const updatedInput =
  (term: string, inputType: string): Thunk =>
    async (dispatch, getState) => {
      const state = getState();
      const engine = selectEngine(state);

      if (!engine) return;

      dispatch(actions.userTyping({ term, inputType }));
      if (term) dispatch(fetchSuggestions({ term, inputType }));
    };

export const toggledFocus =
  (isFocus: boolean): Thunk =>
    async (dispatch, getState) => {
      const state = getState();

      const { SEARCH_BOX_FOCUS_HISTORY } = selectFeatureFlags(state);
      const engine = selectEngine(state);
      dispatch(
        engine
          ? actions.toggledInputFocus(isFocus)
          : actions.toggledChooseEngine(true)
      );

      if (
        engine &&
        !selectSuggestions(state).length &&
        isFocus &&
        (SEARCH_BOX_FOCUS_HISTORY || state.search.provided)
      ) {
        dispatch(updatedInput(state.search.provided, 'focus'));
      }
    };

export const changedInput =
  (evt?: ChangeEvent): Thunk =>
    async (dispatch, getState) => {
      const state = getState();

      const { value } = evt.currentTarget;

      const engine = selectEngine(state);
      if (!engine) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        evt.currentTarget.value = '';

        dispatch(actions.toggledChooseEngine(true));

        return;
      }

      dispatch(updatedInput(value, evt.inputType));
    };

export const searchSubmittedFinal =
  (event: SubmitEvent, suggestion?: Suggestion, provided?: string): Thunk =>
    (dispatch, getState) => {
      const state: GlobalState = getState();

      const term = provided || getTerm(suggestion) || state.search.provided;

      const TARGET_BROWSER = process.env.TARGET_BROWSER || 'chrome';
      const APP_TYPE = process.env.APP_TYPE;

      event?.preventDefault?.();
      const engine = selectEngine(state);

      if (suggestion?.type === 'openTab' && process.env.APP_PLATFORM !== 'web') {
        sendMessage({ type: 'switchTo', tabId: suggestion.id });
        return;
      }

      const choosenSearchTag = selectChoosenSearchTag(state);

      const href = (() => {
        if (suggestion) return suggestion.url;

        if (checkIsUrl(term)) return withHttp(term);

        if (choosenSearchTag) {
          return choosenSearchTag.u.replace('{{{s}}}', encodeURIComponent(term));
        }

        return createOrganicUrl({ term }, engine);
      })();

      const { dailyAdClicksCount } = state.search;

      const [gain, gainType] = ((): [number, string] => {
        if (suggestion?.type === 'ad') {
          return [dailyAdClicksCount < 5 ? getRandomInt(30, 80) : 0, 'ad'];
        }

        if (href.match(ENGINES.oh.url)) {
          return [20, 'oh'];
        }

        return [10, 'various'];
      })();

      if (gainType !== 'oh') {
        dispatch(incrementShells(gain));
      }

      dispatch(
        actions.searchSubmitted({
          gain,
          term,
          isAd: gainType === 'ad',
          searchTag: choosenSearchTag,
          hintId: selectActiveHintId(state),
        })
      );
      // trackSubmit(
      //   event,
      //   suggestion,
      //   engine,
      //   gain,
      //   gainType,
      //   state.search.instantResults.counter,
      //   choosenSearchTag
      // );

      trackSubmit(
        suggestion,
        gain,
        gainType
      );

      window.stop();
      setTimeout(() => {
        if (process.env.APP_PLATFORM === 'web') {
          window.location.href = href;
        } else if (TARGET_BROWSER === 'chrome' && APP_TYPE === 'lite') {
          chrome.search.query({ text: href, disposition: 'CURRENT_TAB' }, () => {
            chrome.tabs.update({ url: href });
          });
        } else {
          window.location.href = href;
        }
      }, 10);
    };

export const searchSubmitted =
  (event: SubmitEvent, suggestion?: Suggestion, provided?: string): Thunk =>
    async (dispatch, getState) => {
      event?.preventDefault?.();

      const state: GlobalState = getState();
      const { search } = state;

      if (search.isSubmitted) return;

      // const { SEARCH_BOX_INSTANT_ANSWERS } = selectFeatureFlags(state);
      // if (!selectChoosenSearchTag(state)) {
      // if (
      //   !suggestion &&
      //   (search.provided !== search.instantResults.data?.queryContext.originalQuery)
      // ) {
      //   updateQuery({ q: search.provided });
      //   dispatch(fetchInstantResults(search.provided));
      //   return;
      // } else

      // if (
      //   ['organic', 'historyOrganic', 'searchTag'].includes(suggestion?.type) &&
      //   search.provided !== suggestion.term
      // ) {
      //   updateQuery({ q: suggestion.term });
      //   dispatch(actions.preselected(suggestion));
      //   dispatch(fetchInstantResults(suggestion.term, true));
      //   dispatch(fetchSuggestions({ term: suggestion.term, inputType: 'preselected' }));
      //
      //   return;
      // }
      // }

      return dispatch(searchSubmittedFinal(event, suggestion, provided));
    };

const navigateNextSearchTag = (): Thunk => (dispatch, getState) => {
  const state = getState();
  const displayedSearchTags = selectDisplayedSearchTags(state);
  const choosen = selectChoosenSearchTag(state);

  const index = displayedSearchTags.findIndex(
    (searchTag) => searchTag.u === choosen?.u
  );
  const nextChoosen =
    index !== -1 ? displayedSearchTags[index + 1] : displayedSearchTags[0];
  dispatch(searchTagSelect(nextChoosen?.u || null));
};

const suggestionNavigate =
  (key: 'ArrowUp' | 'ArrowDown') => (dispatch, getState) => {
    let newIndex;
    const state = getState() as GlobalState;
    const { highlighted } = state.search;
    const list = selectSuggestions(state).filter(
      ({ type }) => type !== 'placeholder'
    );

    if (highlighted.id) {
      const index = list.findIndex(({ id }) => id === highlighted.id);
      newIndex = index + (key === 'ArrowUp' ? -1 : 1);
      if (newIndex < 0 || newIndex >= list.length) {
        newIndex = null;
      }
    } else {
      newIndex = key === 'ArrowUp' ? list.length - 1 : 0;
    }

    const newSuggestion = list[newIndex];
    dispatch(
      actions.suggestionNavigate({
        id: newSuggestion?.id,
        inputType: 'keyboard',
      })
    );
  };

export const keyDown =
  (event: KeyboardEvent): Thunk =>
    (dispatch, getState) => {
      const { key } = event;

      if (
        !['ArrowUp', 'ArrowDown', 'Enter', 'Escape', 'Tab', 'Backspace'].includes(
          key
        )
      )
        return;

      if (key === 'Backspace') {
        if ((event.target as HTMLInputElement).value) return;
        setTimeout(() => {
          dispatch(actions.pressedEscape(true));
        }, 1);

        return;
      }

      event.preventDefault();

      if (key === 'Enter') {
        const state = getState();
        dispatch(searchSubmitted(event, selectHighlighted(state)));
        return;
      }

      if (key === 'Escape') {
        dispatch(actions.pressedEscape(false));
        return;
      }

      if (key === 'ArrowUp' || key === 'ArrowDown') {
        dispatch(suggestionNavigate(key));
        return;
      }

      if (key === 'Tab') {
        dispatch(navigateNextSearchTag());
      }
    };

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const speechEnded =
  (content: string) =>
    (dispatch): void => {
      dispatch(
        content
          ? searchSubmitted({ type: 'speech' }, null, content)
          : actions.speechEnded()
      );
    };

export const removeSuggestion =
  (s: Suggestion): Thunk =>
    async (dispatch, getState) => {
      const state = getState();

      const history = state.search.history.filter((term) => term !== s.term);

      dispatch(actions.removeSuggestion(history));
    };

export const searchTagSelect =
  (u: string, eventType: 'click' | 'keydown' = 'click'): Thunk =>
    (dispatch, getState) => {
      dispatch(actions.searchTagSelected(u));
      const state = getState();

      const term = state.search.provided;

      if (term) {
        dispatch(fetchSuggestions({ term, inputType: 'searchTag' }));
      }
    };
